import React from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button } from "evergreen-ui";
import { Input, Select, Form, message } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import { useAuth } from "../../../AuthContext/AuthContext";

const db = getDatabase(Firebase);
const SubCategoriesActionLayout = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateAdminConfig = canAccessModule("ADMIN_CONFIGS", "create");
	const [form] = Form.useForm();
	const [languages] = useListVals(ref(db, "talmidsdb/languages"));
	const [categories] = useListVals(ref(db, "talmidsdb/categories"));

	const handleCreate = (values) => {
		if (!canCreateAdminConfig) {
			message.error("You do not have permission to create subcategories.");
			return;
		}

		const translations = {};
		if (values.translations) {
			values.translations.forEach(translation => {
				if (translation.languageId && translation.text) {
					translations[translation.languageId] = translation.text;
				}
			});
		}

		const object = {
			categoryID: values.categoryID,
			categoryName: values.categoryName,
			id: uuidv4(),
			subcategoryTranslations: translations
		};

		props.createCallback("subCategories", object.id, object);
		form.resetFields();
		message.success("Subcategory created successfully");
	};

	const handleFailed = (error) => {
		message.error("Failed to create subcategory: " + error.message);
	};

	return (
		<div className="font-Nunito">
			<MDBRow>
				<MDBCol className="px-4">
					<Form
						form={form}
						layout="vertical"
						disabled={!canCreateAdminConfig}
						onFinish={handleCreate}
						onFinishFailed={handleFailed}
					>
						<Form.Item
							name="categoryID"
							label="Parent Category"
							rules={[{ required: true, message: 'Please select a parent category!' }]}
						>
							<Select
								placeholder="Select parent category"
								showSearch
								optionFilterProp="children"
							>
								{categories?.map(category => (
									<Select.Option key={category.id} value={category.id}>
										{category.name}
									</Select.Option>
								))}
							</Select>
						</Form.Item>

						<Form.Item
							name="categoryName"
							label="Subcategory Name"
							rules={[{ required: true, message: 'Please input a subcategory name!' }]}
						>
							<Input placeholder="Enter subcategory name" />
						</Form.Item>

						<Form.List name="translations">
							{(fields, { add, remove }) => (
								<div>
									{fields.map(({ key, name, ...restField }) => (
										<div key={key} style={{
											display: 'flex',
											gap: '16px',
											marginBottom: '16px',
											alignItems: 'flex-end'
										}}>
											<Form.Item
												{...restField}
												name={[name, 'languageId']}
												label="Language"
												rules={[{ required: false, message: 'Required' }]}
												style={{ flex: 1 }}
											>
												<Select
													placeholder="Select language"
													showSearch
													optionFilterProp="children"
												>
													{languages?.map(lang => (
														<Select.Option key={lang.id} value={lang.id}>
															{lang.languageName}
														</Select.Option>
													))}
												</Select>
											</Form.Item>

											<Form.Item
												{...restField}
												name={[name, 'text']}
												label="Translation"
												rules={[{ required: false, message: 'Required' }]}
												style={{ flex: 2 }}
											>
												<Input placeholder="Enter translation text" />
											</Form.Item>

											<MinusCircleOutlined
												onClick={() => remove(name)}
												style={{
													color: '#ff4d4f',
													fontSize: '16px',
													marginBottom: '32px',
													cursor: 'pointer'
												}}
											/>
										</div>
									))}

									<Form.Item>
										<Button
											type="dashed"
											onClick={(e) => {
												e.preventDefault();
												add();
											}}
											disabled={!canCreateAdminConfig}
											block
											icon={<PlusOutlined />}
										>
											Add Translation
										</Button>
									</Form.Item>
								</div>
							)}
						</Form.List>

						<Button
							type="primary"
							htmlType="submit"
							disabled={!canCreateAdminConfig}
							style={{ marginTop: '24px' }}
						>
							Create Subcategory
						</Button>
					</Form>
				</MDBCol>
			</MDBRow>
		</div>
	);
};

export default SubCategoriesActionLayout;
